import React, { useEffect } from 'react';
import { SelectField } from 'components/form';
import { useFormContext, useWatch } from 'react-hook-form';

import { DealSheetFormValues } from '../types';

interface Props {
  rowIndex: number;
}

export const LineItemTypeCell = ({ rowIndex }: Props) => {
  const { control, setValue } = useFormContext<DealSheetFormValues>();

  const parentId = useWatch({ control, name: `charges.${rowIndex}.parentId` });
  const charges = useWatch({ control, name: 'charges' }) ?? [];

  const parent = parentId ? charges.find(item => item?.id === parentId) : null;
  const parentAmountType = parent?.amountType;
  const currentAmountType = charges[rowIndex]?.amountType;

  useEffect(() => {
    if (!parentAmountType || parentAmountType === currentAmountType) return;
    setValue(`charges.${rowIndex}.amountType`, parentAmountType, { shouldValidate: true });
  }, [parentAmountType, currentAmountType, rowIndex, setValue]);

  return (
    <SelectField
      label="Type"
      control={control}
      variant="outlined"
      disabled={!!parentId}
      name={`charges.${rowIndex}.amountType`}
      options={[
        { label: 'Fixed', value: 'flat' },
        { label: 'Percentage', value: 'percent' },
      ]}
    />
  );
};
